
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import { siteUrl } from 'constants/app';
import dynamic from 'next/dynamic';

const Comparison = dynamic(() => import('features/pro-tools/Comparison'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function ComparisonPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Comparison Tools"
        description="Ambil keputusan investasi yang tepat dengan membandingkan data keuangan perusahaan dengan mudah. Sistem kami secara otomatis membantu kamu membandingkan emiten satu dengan emiten lainnya."
        url={`${siteUrl}/info/pro-tools/comparison`}
      />
      <Comparison />
    </HomePageLayout>
  );
}

export default ComparisonPage;
